"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasErrors = void 0;
/**
 * Returns true if the response has errors
 * @param {T} response server side response with validation errors
 * @param response server side response with validation errors
 * @template TResponse response type - must be an IValidationResponse
 * @returns true if any errors are in the response or if the status code is not 200
 */
function hasErrors(response) {
    if (response.status === 200) {
        return false;
    }
    if (response.errors) {
        return true;
    }
    return false;
}
exports.hasErrors = hasErrors;
//# sourceMappingURL=hasErrors.js.map